import { apiConfig } from 'config';
import { swManagerRequest } from './utils';

export const getDefaultSwVersions = () => {
  const url = apiConfig.swManagerGetDefaultVersions();
  const options = { method: 'GET' };

  return swManagerRequest(url, options);
};
